import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';

export const TipsCommissionMaxValueField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<>
			{restaurantForFullInfo?.tipsCommissionPercent !== null && (
				<FullInfoField label="maxValueLabel" value={restaurantForFullInfo?.tipsCommissionMaxValue} />
			)}
		</>
	);
};
